module.exports = __webpack_public_path__ + "static/media/comp-mixing-s.90471d3c.jpg";